import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ExternalLink, LogOut, LayoutDashboard, Tag, Euro, Clock, Disc, Images, Inbox, KeyRound } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/site/Header";

const LIENS = [
  { to: "/admin/tableau-de-bord", label: "Accueil admin", icone: LayoutDashboard },
  { to: "/admin/promotions", label: "Promotions", icone: Tag },
  { to: "/admin/tarifs", label: "Tarifs", icone: Euro },
  { to: "/admin/horaires", label: "Horaires", icone: Clock },
  { to: "/admin/catalogue", label: "Catalogue", icone: Disc },
  { to: "/admin/photos", label: "Photos", icone: Images },
  { to: "/admin/demandes", label: "Demandes", icone: Inbox },
  { to: "/admin/mot-de-passe", label: "Mot de passe", icone: KeyRound },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-brand-light" data-testid="admin-layout">
      <header className="bg-brand-dark text-white sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between gap-3 flex-wrap">
          <Logo clair />
          <div className="flex items-center gap-3">
            <a href="/" target="_blank" rel="noopener noreferrer" data-testid="admin-voir-site"
              className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-redhover font-heading font-semibold uppercase tracking-wider px-5 py-3 text-base transition-colors">
              <ExternalLink size={18} aria-hidden="true" />
              Voir le site
            </a>
            <button
              data-testid="admin-deconnexion"
              onClick={() => { logout(); navigate("/admin"); }}
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 font-heading font-semibold uppercase tracking-wider px-5 py-3 text-base transition-colors"
            >
              <LogOut size={18} aria-hidden="true" />
              Quitter
            </button>
          </div>
        </div>
        <nav className="bg-brand-red" aria-label="Navigation administration">
          <div className="max-w-6xl mx-auto px-4 flex gap-1 overflow-x-auto">
            {LIENS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 whitespace-nowrap font-heading font-semibold uppercase tracking-wider text-base px-4 py-4 transition-colors ${
                    isActive ? "bg-brand-dark text-white" : "text-white/90 hover:bg-brand-redhover"
                  }`
                }
              >
                <l.icone size={18} aria-hidden="true" />
                {l.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
